export default Object.freeze({
  Coordinated: 1,
  Cancelled_DE: 2,
  Cancelled_Prov: 3,
  Completed: 4,
  Approved: 5,
  Denied: 6,
  Extended: 8,
  Confirmed: 9,
  Absence: 10,
  Adjustment: 11,
  Reject: 12,
});
